var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcommbxMobileBrandLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-logo-mobile",
    transform: "translate(-71.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54319",
    "data-name": "Path 54319",
    d: "M146.743,0h-28V24h28Z",
    transform: "translate(-47.524)",
    fill: "#e1251b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54325",
    "data-name": "Path 54325",
    d: "M126.671,11.3a6.192,6.192,0,0,1,2.869-.7,4.969,4.969,0,0,1,3.549,1.278,4.6,4.6,0,0,1,1.351,3.513V17.9a4.613,4.613,0,0,1-1.388,3.675,5.343,5.343,0,0,1-3.674,1.208,12.023,12.023,0,0,1-4.354-.792.306.306,0,0,1-.149-.113.3.3,0,0,1-.055-.178V6.616a.219.219,0,0,1,.009-.1.218.218,0,0,1,.241-.145H126.4c.181,0,.268.083.268.245Zm2.67,9.836q3.206,0,3.206-3.24v-2.5q0-3.138-3.188-3.138a4.628,4.628,0,0,0-2.689.81V20.7A7.406,7.406,0,0,0,129.341,21.131Z",
    transform: "translate(-50.602 -2.367)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54326",
    "data-name": "Path 54326",
    d: "M149.878,19.617l3.928,5.582c.139.213.083.315-.157.315h-1.67a.315.315,0,0,1-.3-.157L148.75,20.9l-2.938,4.453a.328.328,0,0,1-.314.157h-1.675c-.24,0-.3-.1-.157-.315l3.933-5.582-3.7-5.471a.2.2,0,0,1-.056-.1.2.2,0,0,1,.01-.114c.028-.069.1-.1.2-.1h1.582a.393.393,0,0,1,.179.052.4.4,0,0,1,.136.129l2.776,4.3,2.776-4.3a.381.381,0,0,1,.3-.18h1.582a.223.223,0,0,1,.121.02.22.22,0,0,1,.092.082.185.185,0,0,1,.019.112.182.182,0,0,1-.052.1Z",
    transform: "translate(-58.113 -5.353)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommbxMobileBrandLogo);
export default __webpack_public_path__ + "static/media/ecommbxMobileBrandLogo.90267aaa78f5acc968707cb899bddad6.svg";
export { ForwardRef as ReactComponent };